import React from 'react';
// import * as yup from 'yup';

import { useFormatMessage } from 'hooks';
// import UserForm from 'components/UserForm';
import ChangePassword from './ChangePassword';

const Profile = () => {
  document.title = 'Wranglr — Profile';
  
  return (
    <>
      <section className="hero is-hero-bar">
        <div className="hero-body">
          <h1 className="title">{useFormatMessage('Profile.profile')}</h1>
        </div>
      </section>
      <section className="section is-main-section">
        <ChangePassword />
      </section>
    </>
  );
};

export default Profile;
